import { createStore } from 'vuex';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const store = createStore({
    state: {
      token: getCookie("apiToken") || false,
      agencies: [],
      companies: [],
      connectionRequests: [],
      transactions: [],
      tickets: [],
      analytics: [],
      ticketsCountByStep: getTicketsCountByStep(),
      balance: 0,
      notifications: [],
      settings: {},
      angecyInfo: {},
      credentials: [],
      emptyCredentials: [],
      login: {
        currentUI: 'initial',
        authMethod: 'otp',
        currentEmail: '',
      },
      onboarding: {
        currentUI: 'initial'
      },
      accountInfo: {
        first_name: '',
        last_name: '',
        user_type: '',
        phone: '',
        company: '',
        demo_user: false,
        logo: ''
      },
      searchResult: {origin_destinations: [{}]},
      searchCommand: {command: null, source: null},
      searchState: 'start',
      bookings: [],
      bookingNotifications: [],
      formOfPayments: [],
      defaultBookings: [],
      openedBooking: {},
      bookingLoader: false,
      priceCalculationError: false,
      selectedBookingList: 'new',
      searchReissue: false,
      reissueOffers: [],
      reissueSearchParams: {},
      lastSearchParams: null,
      hiddenBooking: {},
      searchFilters: {},
      searchFilterSources: {},
      connectionFilterRevision: 0,
      // Carriers the offers on screen were fetched with. Empty means no carrier
      // restriction applies, so narrowing by carrier is pure frontend work —
      // the state to start from, since the server scopes a search only when it
      // says so. Null means a search reported nothing, and only then is the
      // answer unknown.
      serverCarrierScope: [],
      extraFilters: [],
      sortPreference: {
        value: 'smart',
        source: 'default',
        baseline: { value: 'smart', source: 'default' },
      },
    },
    getters,
    mutations,
    actions
});

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? matches[1] : undefined;
}

function getTicketsCountByStep(){
  if (document.documentElement.clientHeight < 500) return 5
  return Math.floor((document.documentElement.clientHeight - 200)/18) + 1
}
